import useAccountPopoverStore from "@casino/legacy/client/store/useAccountPopoverStore";
import type { AuthTab } from "@casino/ui/Games/hooks/useAuthGate";
import AuthTabContext from "@casino/ui/Games/LoginAreaPopover/AuthTabContext";
import { useContext } from "react";

// An absent AuthTabContext selects the legacy popover, which has no tabs and calls the register view "signup".
const useAuthTabSwitch = () => {
  const switchTabInProfileForm = useContext(AuthTabContext);
  const { showPopover } = useAccountPopoverStore();

  return (tab: AuthTab) => {
    if (switchTabInProfileForm) {
      switchTabInProfileForm(tab);
      return;
    }
    showPopover(tab === "register" ? "signup" : "login");
  };
};

export default useAuthTabSwitch;
